import MonthInput, { MonthInputProps } from "@components/MonthInput";
import {
  Control,
  FieldValues,
  Path,
  UseControllerProps,
  useController,
} from "react-hook-form";

interface ControlledMonthInputProps<T extends FieldValues>
  extends Omit<MonthInputProps, "value" | "onChange" | "onBlur"> {
  control: Control<T>;
  name: Path<T>;
  rules?: UseControllerProps<T>["rules"];
}

const ControlledMonthInput = <T extends FieldValues>({
  control,
  name,
  rules,
  ...props
}: ControlledMonthInputProps<T>) => {
  const { field, fieldState } = useController({ control, name, rules });
  return (
    <MonthInput
      {...field}
      {...props}
      errorMessage={fieldState.error?.message}
    />
  );
};

export default ControlledMonthInput;
